import { defineComponent, computed, createBlock, openBlock, normalizeClass, withCtx, createElementBlock, createCommentVNode, createElementVNode, resolveDynamicComponent, renderSlot, createTextVNode } from 'vue';
import _sfc_main$2 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es133.js';
import RenderlessComponent from './basler-components.es275.js';

const _hoisted_1 = {
  key: 0,
  class: "button__animated-border-box"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "LinkElement",
  props: {
    link: {},
    styleType: { default: "default" },
    targetBlank: { type: Boolean },
    size: { default: "medium" },
    iconType: { default: "no-icon" },
    iconName: {},
    cssClass: {}
  },
  setup(__props) {
    const props = __props;
    const target = computed(() => {
      if (props.targetBlank) {
        return "_blank";
      }
      if (typeof props.link === "object") {
        const t = props.link;
        return t.target;
      }
      return "";
    });
    const baseClassName = props.styleType === "default" ? "link" : "button";
    const cssClassNames = computed(() => {
      if (props.cssClass) {
        return props.cssClass;
      }
      return {
        [`${baseClassName}`]: true,
        [`${baseClassName}--${props.size || "medium"}`]: true,
        [`${baseClassName}--${props.styleType || "default"}`]: true,
        [`${baseClassName}--${props.iconType || "no-icon"}`]: true
      };
    });
    const hyperUrl = computed(() => {
      if (typeof props.link === "object") {
        return props.link.uri;
      }
      return props.link;
    });
    const rel = computed(() => {
      if (typeof props.link === "object") {
        return props.link.rel;
      }
      return void 0;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        uri: hyperUrl.value,
        target: target.value,
        class: normalizeClass(cssClassNames.value),
        rel: rel.value
      }, {
        default: withCtx(() => [
          _ctx.styleType === "remarkable" ? (openBlock(), createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            createElementVNode("div", { class: "button__animated-border-trail" }, null, -1)
          ]))) : createCommentVNode("", true),
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.styleType === "remarkable" ? "span" : RenderlessComponent), {
            class: normalizeClass({ button__content: _ctx.styleType === "remarkable" })
          }, {
            default: withCtx(() => [
              _ctx.iconType === "icon-left" && _ctx.iconName ? (openBlock(), createBlock(_sfc_main$2, {
                key: 0,
                name: _ctx.iconName,
                size: "dynamic"
              }, null, 8, ["name"])) : createCommentVNode("", true),
              _ctx.iconType !== "icon-only" ? renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
                _cache[1] || (_cache[1] = createTextVNode("Link"))
              ]) : _ctx.iconName ? (openBlock(), createBlock(_sfc_main$2, {
                key: 2,
                name: _ctx.iconName,
                size: "dynamic"
              }, null, 8, ["name"])) : createCommentVNode("", true),
              _ctx.iconType === "icon-right" && _ctx.iconName ? (openBlock(), createBlock(_sfc_main$2, {
                key: 3,
                name: _ctx.iconName,
                size: "dynamic"
              }, null, 8, ["name"])) : createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["class"]))
        ]),
        _: 3
      }, 8, ["uri", "target", "class", "rel"]);
    };
  }
});

export { _sfc_main as default };
